<!-- Header -->
<h3 mat-dialog-title translate>
    Delete Topic
</h3>

<!-- Body -->
<mat-dialog-content>
    <p style="padding: 10px" translate>
        This will delete the topic
    </p>
    <p style="padding-left: 30px">
        {{information.Title}}
    </p>
    <p style="padding:10px" translate>
        and all associated content below it.
    </p>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="footerRight">
        <tyl-button image="save.png" label="Delete" (clickEvent)="delete()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>